import { gql } from '@apollo/client';

export const UPDATE_REPORT_GEN_CONFIG = gql`
  mutation UpdateReportGenConfig($reportGenConfigUpdateDto: ReportGenConfigUpdateDto!) {
    updateReportGenConfig(reportGenConfigUpdateDto: $reportGenConfigUpdateDto) {
      columns {
        id
        label
      }
      id
      name
      portfolioId
    }
  }
`;
